<template>
    <modal-content @close="$emit('close')">
        <project-token-form ref="form" @o3-submit="onSubmit($event)"/>
    </modal-content>
</template>

<script>
import ProjectTokenForm from '@/modules/ProjectModule/modules/ExtensionModule/components/ProjectToken/ProjectTokenForm';
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';
import DisplayProjectTokenDialog
    from '@/modules/ProjectModule/modules/ExtensionModule/components/ProjectToken/DisplayProjectTokenDialog';
import {defaultModalParameters} from "domovio-core/src/system/modal/modal.params";

export default {
    components: {ModalContent, ProjectTokenForm},
    methods:    {
        onSubmit(data) {
            this.$store.dispatch('projects/project/extension/projectToken/createProjectToken', data)
                .then(({unMaskedBearer}) => {
                    this.$dmv.notifySuccess('Založeno');
                    this.$refs.form.reset();
                    this.$emit('close');
                    setTimeout(() => this.display(unMaskedBearer), 200);
                });
        },
        display(bearer) {
            this.$modal.show(DisplayProjectTokenDialog, {
                bearer
            }, defaultModalParameters({
                maxWidth: 750,
                width:    750
            }));
        }
    }
}
</script>
